import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
// import { ToasterService } from 'angular2-toaster';
// import { WebServiceService } from '../../shared/services/web-service.service';
// import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
@Component({
  selector: 'app-generic-attachment',
  templateUrl: './generic-attachment.component.html',
  styleUrls: ['./generic-attachment.component.scss']
})
export class GenericAttachmentComponent implements OnInit {

  @Input() attachment: any;
  @Input() title: any;
  @Input() showListIcon: any = false;
  @Input() iconOnly: any = false;
  isSupportingListOpen = false;
  @HostBinding('class.sd-icon-only')
  get supportingIconOnly() {
    return this.iconOnly === true || this.iconOnly === 'true';
  }
  // company_setup: any = {};
  // isProcessing:boolean=true;
  @Output()
  sendAction = new EventEmitter()
  constructor(){

  }
  // constructor(private toasterService: ToasterService, private webService: WebServiceService,public _localStorageService: LocalStorageService) {
  // }
  ngOnInit() {
    this.attachment=Array.isArray(this.attachment)?this.attachment:[];
    // this.GetCompanySetUpData();
  }
  getFile(url: string) {
    if (url) {
      window.open(url, '_blank');
      // window.location.href = url ? url : ''
    }
  }

  openSupportingList(event: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isSupportingListOpen = true;
  }

  closeSupportingList() {
    this.isSupportingListOpen = false;
  }

  supportingFileName(row: any) {
    if (!row) {
      return '';
    }
    let name = row.attachment_name || row.filename || row.name || row.attachment || '';
    const type = (row.filetype || row.attchement_type || '').toString();
    if (name && type && type.length <= 10 && name.toLowerCase().indexOf('.' + type.toLowerCase()) === -1) {
      name = name + '.' + type;
    }
    return name;
  }

  supportingFileUrl(row: any) {
    if (!row) {
      return '';
    }
    return row.display || row.url || row.attachment_url || row.attachments_url || '';
  }

  openSupportingFile(row: any) {
    this.getFile(this.supportingFileUrl(row));
  }
  
  // GetCompanySetUpData() {
  //   // if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
  //   //   return false;
  //   // }
  //   let req = {
  //   }
  //   this.company_setup = {}
  //   this.isProcessing=true;
  //  this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
  //     data => {
  //       if (data.status) {
  //         this.company_setup = {}
  //         this.company_setup = data.response ? data.response : {}

  //         this.title=this.company_setup.custom_name_for_supporting_document?this.company_setup.custom_name_for_supporting_document:'Attachments';

  //       }
  //       else {
  //         this.toasterService.pop('error', "Error", data.message);
  //       }
  //       this.isProcessing=false;
  //     }, error => {
  //       this.isProcessing=false;
  //       this.toasterService.pop("error", "Error", "Something Went Wrong");

  //     }
  //   )
  // }
}



// WEBPACK FOOTER //
// /codebuild/output/src825240186/src/src/app/generic-ui-components/generic-attachment/generic-attachment.component.ts